import {sortCaret} from "../../../../_metronic/_helpers";
import * as formatter from "../../../../utils/formatter";
import {SAMPLE_REQUEST_STATUS} from "../../../../utils/codes";
// import {format, subDays} from "date-fns";

export const defaultSorted = [{ dataField: "reqSeq", order: "asc" }];

export const sampleReqStatus = SAMPLE_REQUEST_STATUS.map(({key, label}) => ({ key, label }));

export const sizePerPageList = [
  { text: "10개 보기", value: 10 },
  { text: "30개 보기", value: 30 },
  { text: "50개 보기", value: 50 },
  { text: "100개 보기", value: 100 },
];

export const initialFilter = {
  filter: {
    goodsNo: "",
    goodsNm: "",
    rplySttsCd: "",
    startDt: "",
    endDt: "",
  },
  sortOrder: "asc",
  sortField: "reqSeq",
  pageNumber: 1,
  pageSize: 30,
};

export const columns = [
  {
    keyField: "reqSeq",
    dataField: "reqSeq",
    text: "No.",
    headerClasses: 'text-center',
    classes: 'text-center',
    sort: true,
    sortCaret: sortCaret,
  },
  {
    keyField: "reqSeq",
    dataField: "goodsNo",
    text: "신청 상품 코드",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "reqSeq",
    dataField: "goodsNm",
    text: "신청 상품명",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.prodName,
  },
  {
    keyField: "reqSeq",
    dataField: "goodsOptList",
    text: "옵션",
    headerClasses: 'text-center',
    classes: 'text-left',
    formatter: formatter.goodsDetailOpt,
  },
  {
    keyField: "reqSeq",
    dataField: "salePrc",
    text: "공급가",
    headerClasses: 'text-center',
    classes: 'text-right',
    formatter: formatter.price,
  },
  {
    keyField: "reqSeq",
    dataField: "regDtime",
    text: "샘플 신청 일",
    headerClasses: 'text-center',
    classes: 'text-center',
    sort: true,
    sortCaret: sortCaret,
    formatter: formatter.date,
  },
  {
    keyField: "reqSeq",
    dataField: "rplySttsCd",
    text: "판매 상태",
    headerClasses: 'text-center',
    classes: 'text-center',
    formatter: formatter.chip(SAMPLE_REQUEST_STATUS),
  },
];
